/**
 * @param {*}      global
 * @param {Number} startOffset
 */
export default function computeStartRangeRectBounds(global, startOffset) {
  const globalSelection = global.getSelection();

  if (globalSelection.rangeCount === 0) {
    return null;
  }

  const rangeClone = globalSelection.getRangeAt(0).cloneRange();

  if (startOffset >= 0) {
    rangeClone.setStart(rangeClone.startContainer, startOffset);
  }

  const boundingRect = rangeClone.getBoundingClientRect();

  return {
    top: boundingRect.bottom + window.pageYOffset,
    left: boundingRect.left + window.pageXOffset,
  };
}
